(function () {
  
    /* On ouvre tous les liens externes dans un nouvel onglet */
    document.querySelectorAll("a").forEach((item) => {
      var a = new RegExp("/" + window.location.host + "/");
      if (!a.test(item.href)) item.setAttribute("target", "_blank");
    });
  
    var comp = document.querySelectorAll("#splide-featured");
    if (!comp) return;
    comp.forEach((element) => {
      new Splide(element, {
        perPage: 3,
        arrows: true,
        breakpoints: {
          1000: {
            perPage: 2,
          },
          768: {
            padding: {
              left: "30px",
            },
          },
          550: {
            perPage: 1,
            gap: "1rem",
          },
          400: {
            padding: {
              right: "4rem",
            },
          }
        },
        padding: {
          right: "6rem",
        },
      }).mount();
    });
  
  })();